import { BudgetsListPage, BudgetFormPage, BudgetDetailPage, BudgetFollowUpPage } from './pages/budgets';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { UnsavedChangesProvider } from './contexts/UnsavedChangesContext';
import { PrivateRoute } from './components/PrivateRoute';
import { MainLayout } from './components/layout';
import { ConfiguracionPage } from './pages/ConfiguracionPage';
import {
  LoginPage,
  DashboardPage,
  UnauthorizedPage,
  ChangePasswordPage,
} from './pages';
import {
  PatientsListPage,
  PatientFormPage,
  PatientDetailPage,
} from './pages/patients';
import { SiteCatalogPage } from './pages/catalog';
import { RemindersPage } from './pages/RemindersPage';
import {
  SpecialtiesAdminPage,
  SubspecialtiesAdminPage,
  TreatmentGroupsAdminPage,
  MedicalActsAdminPage,
  SocietiesAdminPage,
  RejectionTypesAdminPage,
  DocumentTypesAdminPage,
  InsuranceCompaniesPage,
  PoliciesAdminPage,
  TariffsAdminPage,
  TemplatesAdminPage,
  SitesAdminPage,
  UsersAdminPage,
  CompanyAdminPage,
  DiscountsAdminPage,
  TreatmentsAdminPage,
  ContactTypesAdminPage,
  WhatsAppAdminPage,
  ReminderTemplatesAdminPage,
  SystemHealthPage,
} from './pages/admin';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <UnsavedChangesProvider>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/unauthorized" element={<UnauthorizedPage />} />

          {/* Cambio de contraseña obligatorio */}
          <Route
            path="/cambiar-contrasena"
            element={
              <PrivateRoute>
                <ChangePasswordPage />
              </PrivateRoute>
            }
          />

          {/* Protected routes with layout */}
          <Route
            element={
              <PrivateRoute>
                <MainLayout />
              </PrivateRoute>
            }
          >
            {/* Dashboard */}
            <Route path="/dashboard" element={<DashboardPage />} />

            {/* Pacientes */}
            <Route path="/pacientes" element={<PatientsListPage />} />
            <Route path="/pacientes/nuevo" element={<PatientFormPage />} />
            <Route path="/pacientes/:id" element={<PatientDetailPage />} />
            <Route path="/pacientes/:id/editar" element={<PatientFormPage />} />

            {/* Presupuestos - Fase 5 */}
            <Route path="/presupuestos" element={<BudgetsListPage />} />
            <Route path="/presupuestos/nuevo" element={<BudgetFormPage />} />
            <Route path="/presupuestos/:id/editar" element={<BudgetFormPage />} />
            <Route path="/presupuestos/:id" element={<BudgetDetailPage />} />

            {/* Seguimiento de presupuestos */}
            <Route path="/seguimiento-presupuestos" element={<BudgetFollowUpPage />} />

            {/* Recordatorios */}
            <Route path="/recordatorios" element={<RemindersPage />} />

            {/* ============================================================ */}
            {/* CATÁLOGOS DEL CENTRO - Requiere GESTOR_SEDE o ADMIN */}
            {/* ============================================================ */}
            <Route
              path="/catalogos/centro"
              element={
                <PrivateRoute requiredRoles={['GESTOR_SEDE', 'ADMIN']}>
                  <SiteCatalogPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/catalogos/tratamientos"
              element={
                <PrivateRoute requiredRoles={['GESTOR_SEDE', 'ADMIN']}>
                  <TreatmentsAdminPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/catalogos/plantillas"
              element={
                <PrivateRoute requiredRoles={['GESTOR_SEDE', 'ADMIN']}>
                  <TemplatesAdminPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/catalogos/descuentos"
              element={
                <PrivateRoute requiredRoles={['GESTOR_SEDE', 'ADMIN']}>
                  <DiscountsAdminPage />
                </PrivateRoute>
              }
            />

            {/* ============================================================ */}
            {/* CATÁLOGOS MAESTROS - Requiere rol ADMIN */}
            {/* ============================================================ */}
            <Route
              path="/admin/especialidades"
              element={
                <PrivateRoute requiredRoles={['ADMIN']}>
                  <SpecialtiesAdminPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/subespecialidades"
              element={
                <PrivateRoute requiredRoles={['ADMIN']}>
                  <SubspecialtiesAdminPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/grupos-tratamiento"
              element={
                <PrivateRoute requiredRoles={['ADMIN']}>
                  <TreatmentGroupsAdminPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/actos-medicos"
              element={
                <PrivateRoute requiredRoles={['ADMIN']}>
                  <MedicalActsAdminPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/sociedades"
              element={
                <PrivateRoute requiredRoles={['ADMIN']}>
                  <SocietiesAdminPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/tipos-rechazo"
              element={
                <PrivateRoute requiredRoles={['ADMIN']}>
                  <RejectionTypesAdminPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/tipos-documento"
              element={
                <PrivateRoute requiredRoles={['ADMIN']}>
                  <DocumentTypesAdminPage />
                </PrivateRoute>
              }
            />

            <Route
              path="/admin/whatsapp"
              element={
                <PrivateRoute requiredRoles={['GESTOR_SEDE', 'ADMIN']}>
                  <WhatsAppAdminPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/plantillas-recordatorio"
              element={
                <PrivateRoute requiredRoles={['ADMIN']}>
                  <ReminderTemplatesAdminPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/tipos-contacto"
              element={
                <PrivateRoute requiredRoles={['ADMIN']}>
                  <ContactTypesAdminPage />
                </PrivateRoute>
              }
            />

            {/* ============================================================ */}
            {/* TARIFAS Y PRECIOS - Requiere rol ADMIN */}
            {/* ============================================================ */}
            <Route
              path="/admin/aseguradoras"
              element={
                <PrivateRoute requiredRoles={['ADMIN']}>
                  <InsuranceCompaniesPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/polizas"
              element={
                <PrivateRoute requiredRoles={['ADMIN']}>
                  <PoliciesAdminPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/tarifas"
              element={
                <PrivateRoute requiredRoles={['ADMIN']}>
                  <TariffsAdminPage />
                </PrivateRoute>
              }
            />

            {/* ============================================================ */}
            {/* ADMINISTRACIÓN - Requiere rol ADMIN */}
            {/* ============================================================ */}
            <Route
              path="/admin/usuarios"
              element={
                <PrivateRoute requiredRoles={['ADMIN']}>
                  <UsersAdminPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/sedes"
              element={
                <PrivateRoute requiredRoles={['ADMIN']}>
                  <SitesAdminPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin/empresa"
              element={
                <PrivateRoute requiredRoles={['ADMIN']}>
                  <CompanyAdminPage />
                </PrivateRoute>
              }
            />

            {/* Configuración - Accesible para GESTOR_SEDE y ADMIN */}
            <Route
              path="/configuracion"
              element={
                <PrivateRoute requiredRoles={['GESTOR_SEDE', 'ADMIN']}>
                  <ConfiguracionPage />
                </PrivateRoute>
              }
            />
            {/* ============================================================ */}
            {/* SALUD DEL SISTEMA - Solo ADMIN (Dashboard v2) */}
            {/* ============================================================ */}
            <Route
              path="/admin/sistema"
              element={
                <PrivateRoute requiredRoles={['ADMIN']}>
                  <SystemHealthPage />
                </PrivateRoute>
              }
            />


            {/* Redirect root to dashboard */}
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
          </Route>

          {/* Catch all - redirect to dashboard */}
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </UnsavedChangesProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
